import { api } from "../../services/Api.js";
import Vue from 'vue';

export function get_documents({ commit, state }, payload ){

    // adding token
    payload.token=state.appSettings.token

   
    // get active school
    var school = state.user_schools.find(school => school.active === 1);
    
    
    // return chainable promise
    return api
    .post(school,"get_downloads.php",payload)
    .then( result =>{ 
     
      commit('SET_DOCUMENTS', {store_key:payload.store_key,documents:result.data});
      
      
    })
    .catch( error => {
      Vue.$toaster.toast("[error: action get_documents]" + error);
     
    })
    

}